import axios from "../axiosApi";
import {
    FETCH_DISCIPLINE_OFFERS, RECEIVE_DISCIPLINE_OFFERS,
    SAVE_DISCIPLINE_OFFER, SAVE_DISCIPLINE_OFFER_SUCCESS,
    DELETE_DISCIPLINE_OFFER, DELETE_DISCIPLINE_OFFER_SUCCESS,
    FETCH_DOF_STUDENTS, RECEIVE_DOF_STUDENTS
} from "../actionTypes";

export const getDisciplineOffers = (teacherId?: number | null, periodId?: number | null) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_DISCIPLINE_OFFERS });
        try {
            const filterObj: any = {
                "include": [
                    { "classOffer": "level" },
                    "period",
                    "teacher",
                    { "disciplineModule": { "discipline": "level" } }
                ]
            };
            const where: any = {};
            if (teacherId) where.Teacher_id = teacherId;
            if (periodId) where.Period_id = periodId;
            if (Object.keys(where).length > 0) filterObj.where = where;
            const filter = JSON.stringify(filterObj);
            const response = await axios.get(`/DisciplineOffers?filter=${filter}`);
            dispatch({ type: RECEIVE_DISCIPLINE_OFFERS, payload: response.data });
        } catch (e) {
            console.error("getDisciplineOffers ERROR", e);
            dispatch({ type: RECEIVE_DISCIPLINE_OFFERS, payload: [] });
        }
    }
}

export const saveDisciplineOffer = (data: any) => {
    return async (dispatch: any) => {
        dispatch({ type: SAVE_DISCIPLINE_OFFER });
        try {
            let response;
            if (data.id) {
                const id = data.id;
                delete data.id;
                response = await axios.put(`/DisciplineOffers/${id}`, data);
            } else {
                if (data.id === null) delete data.id;
                response = await axios.post('/DisciplineOffers', data);
            }
            dispatch({ type: SAVE_DISCIPLINE_OFFER_SUCCESS, payload: response.data });
            dispatch(getDisciplineOffers());
        } catch (e) {
            console.error("saveDisciplineOffer ERROR", e);
            dispatch({ type: SAVE_DISCIPLINE_OFFER_SUCCESS, payload: { error: true } });
        }
    }
}

export const deleteDisciplineOffer = (id: number) => {
    return async (dispatch: any) => {
        dispatch({ type: DELETE_DISCIPLINE_OFFER });
        try {
            await axios.delete(`/DisciplineOffers/${id}`);
            dispatch({ type: DELETE_DISCIPLINE_OFFER_SUCCESS });
            dispatch(getDisciplineOffers());
        } catch (e) {
            console.error("deleteDisciplineOffer ERROR", e);
        }
    }
}

export const getDofStudents = (dofId: number) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_DOF_STUDENTS });
        try {
            const response = await axios.get(`/DisciplineOffers/${dofId}/students`);
            dispatch({ type: RECEIVE_DOF_STUDENTS, payload: response.data });
        } catch (e) {
            console.error("getDofStudents ERROR", e);
            dispatch({ type: RECEIVE_DOF_STUDENTS, payload: [] });
        }
    }
}

export const getDofStudentCounts = async (periodId?: number | null): Promise<Record<number, { total: number; ativos: number }>> => {
    try {
        const url = periodId
            ? `/DisciplineOffers/getStudentCountsAll?periodId=${periodId}`
            : '/DisciplineOffers/getStudentCountsAll';
        const response = await axios.get(url);
        const map: Record<number, { total: number; ativos: number }> = {};
        (response.data || []).forEach((r: any) => {
            map[r.id] = { total: Number(r.total) || 0, ativos: Number(r.ativos) || 0 };
        });
        return map;
    } catch (e) {
        console.error('getDofStudentCounts ERROR', e);
        return {};
    }
};

export const getDofStudentSummary = async (dofId: number): Promise<any[]> => {
    try {
        const response = await axios.get(`/DisciplineOffers/getStudentSummaryByDof?dofId=${dofId}`);
        return response.data || [];
    } catch (e) {
        console.error('getDofStudentSummary ERROR', e);
        return [];
    }
};

export const updateStudentOrder = (dofId: number, data: any) => {
    return async (dispatch: any) => {
        try {
            await axios.put(`/DisciplineOffers/${dofId}/updateStudentOrder`, data);
            dispatch(getDofStudents(dofId));
        } catch (e) {
            console.error("updateStudentOrder ERROR", e);
        }
    }
}
